/**
 * Central toast helper functions
 *
 * Provides consistent, human-readable notifications across the app.
 * Uses Sonner under the hood.
 */
import { toast } from 'sonner';

/**
 * Show a success toast
 */
export function showSuccess(message: string) {
  toast.success(message, { duration: 3000 });
}

/**
 * Show an error toast
 */
export function showError(message: string) {
  toast.error(message, { duration: 5000 });
}

/**
 * Show a warning toast
 */
export function showWarning(message: string) {
  toast.warning(message, { duration: 4000 });
}

/**
 * Show a persistent offline banner
 */
export function showOfflineBanner() {
  return toast.warning('You are offline. Some features may not work.', {
    id: 'offline-banner',
    duration: Infinity,
  });
}

/**
 * Dismiss the offline banner
 */
export function hideOfflineBanner() {
  toast.dismiss('offline-banner');
}
